import { cn } from '@latitude/token-utils';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import RadioGroupItem from 'RadioGroupItem';
import RadioGroupItemLabel from 'RadioGroupItemLabel';
import type { ComponentRef, Ref } from 'react';
import type { RadioGroupProps } from 'types';

const RadioGroup = ({
  className,
  options = [],
  children,
  rawProps,
  onChange,
  invalid,
  ref: forwardedRef,
  ...props
}: RadioGroupProps & {
  ref?: Ref<ComponentRef<typeof RadioGroupPrimitive.Root>>;
}) => (
  <RadioGroupPrimitive.Root
    ref={forwardedRef}
    className={cn('group', className)}
    onValueChange={onChange}
    aria-invalid={invalid}
    {...props}
    {...rawProps}
  >
    {/* We don't want to use both children and options */}
    {children ||
      options.map((opt, index) => {
        const idToUse = opt.id ?? `${opt.value}-${index}`;
        return (
          <RadioGroupItemLabel
            key={idToUse}
            htmlFor={idToUse}
            {...opt.labelProps}
          >
            <RadioGroupItem
              value={opt.value}
              disabled={opt.disabled}
              id={idToUse}
              data-testid={idToUse}
              {...opt.itemProps}
            />
            {opt.label}
          </RadioGroupItemLabel>
        );
      })}
  </RadioGroupPrimitive.Root>
);

RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
